import becomeKingSound from './sounds/becomeKing.ogg'
import captureSound from './sounds/capture.ogg'
import drawProposalSound from './sounds/drawProposal.mp3'
import moveSound from './sounds/move.ogg'
import startGameSound from './sounds/startGame.mp3'
import timeRunningOutSound from './sounds/timeRunningOut.mp3'
import resultWinSound from './sounds/resultWin.mp3'
import resultLossSound from './sounds/resultLoss.ogv'
import resultDrawSound from './sounds/resultDraw.mp3'

export const BECOME_KING_SOUND = 'become-king'
export const CAPTURE_SOUND = 'capture'
export const DRAW_PROPOSAL_SOUND = 'draw-proposal'
export const MOVE_SOUND = 'move'
export const START_GAME_SOUND = 'start-grame'
export const TIME_RUNNING_OUT = 'time-running-out'
export const RESULT_WIN_SOUND = 'result-win'
export const RESULT_LOSS_SOUND = 'result-loss'
export const RESULT_DRAW_SOUND = 'result-draw'

export default class SoundManager {
  static initialize() {
    this._sounds = {
      [BECOME_KING_SOUND]: new Audio(becomeKingSound),
      [CAPTURE_SOUND]: new Audio(captureSound),
      [DRAW_PROPOSAL_SOUND]: new Audio(drawProposalSound),
      [MOVE_SOUND]: new Audio(moveSound),
      [START_GAME_SOUND]: new Audio(startGameSound),
      [TIME_RUNNING_OUT]: new Audio(timeRunningOutSound),
      [RESULT_WIN_SOUND]: new Audio(resultWinSound),
      [RESULT_LOSS_SOUND]: new Audio(resultLossSound),
      [RESULT_DRAW_SOUND]: new Audio(resultDrawSound),
    }

    this._enabled = true

    this._sounds[START_GAME_SOUND].volume = 0.05
    this._sounds[CAPTURE_SOUND].volume = 0.2
    this._sounds[TIME_RUNNING_OUT].volume = 0.1
  }

  static setEnabled(enabled) {
    this._enabled = enabled
  }

  static isPlaying(soundId) {
    return this._sounds[soundId].currentTime > 0 && !this._sounds[soundId].ended
  }

  static play(soundId, rewind = true) {
    if (!this._enabled) {
      return
    }

    if (rewind) {
      this._sounds[soundId].currentTime = 0
    }

    if (this._sounds[soundId].currentTime === 0) {
      this._sounds[soundId].play()
    }
  }

  static stop(soundId) {
    this._sounds[soundId].pause()
    this._sounds[soundId].currentTime = 0
  }

  static stopAll() {
    Object.entries(this._sounds).forEach(([key, audio]) => audio.pause())
  }
}
